import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelfAttendanceEarlyRenewalComponent } from './early-renewal.component';
import { RenewalInfoModule } from "src/app/shared/components/renewal-info/renewal-info.module";
import { PaymentFormModule } from "src/app/shared/components/payment-form/payment-form.module";
import { HeroModule } from 'src/app/shared/components/hero/hero.module';

@NgModule({
  imports: [
    CommonModule,
    RenewalInfoModule,
    
    PaymentFormModule,
    HeroModule
],
  exports: [
    SelfAttendanceEarlyRenewalComponent
  ],
  providers: [
  ],
  declarations: [
    SelfAttendanceEarlyRenewalComponent
  ]
})

export class SelfAttendanceEarlyRenewalModule { }
